import { DropdownMenu } from '@octopus-do/octopus-storybook'
import { AngleDown } from '@octopus-do/octopus-storybook/icons'
import React from 'react'

import { clsJoin } from '@/utils'
import css from './styles.module.css'

interface Props {
  title: string
  disabled: boolean
}

export const SelectButton = React.forwardRef<HTMLButtonElement, Props>(
  ({ title, disabled }, ref) => {
    const { active, open } = DropdownMenu.useTrigger()

    const handleOpen = () => {
      if (disabled) {
        return
      }

      open()
    }

    return (
      <button
        ref={ref}
        disabled={disabled}
        className={clsJoin(css.button, active && css.active)}
        onPointerDown={handleOpen}
      >
        <span>{title}</span> {!disabled && <AngleDown className={css.icon} />}
      </button>
    )
  }
)
